import { createFileRoute } from '@tanstack/react-router'
import { TutorialPage } from '#/components/landing/tutorial-page'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/tutorial')({
  head: () => ({
    meta: [
      { title: m.mk_tut_meta_title() },
      { name: 'description', content: m.mk_tut_meta_desc() },
      { property: 'og:title', content: m.mk_tut_meta_title() },
      { property: 'og:description', content: m.mk_tut_meta_desc() },
      { property: 'og:type', content: 'article' },
    ],
  }),
  component: TutorialPage,
})
